export enum WidgetTab {
  swap = 'Swap',
  bridge = 'Bridge',
  fiat = 'Fiat',
  portfolio = 'Portfolio',
}
